import { NgRedux } from '@ptl/angular-redux-store';
import { Injectable } from '@angular/core';
import { StateStructure } from '@ptl/state';
import { setPassiveReferralEmail, setPassiveReferralId } from '../reducers/passive-referral-loader.reducer';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { BrandingConfigurationService } from '@ptl/brand';
import { ProducerUrlSessionObject } from '../interfaces/passive-referral-loader.interface';
import { PassiveReferralsComponent } from '../../passive-referrals/passive-referrals.component';
import { saveReferralType } from 'src/app/angular-elements/shared/components/configs/reducers/globalData.reducer';
import { URL_PARAM_REFERRAL_TYPE } from 'src/app/angular-elements/shared/components/configs/interfaces/globalStateStructure.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

export interface ExactTargetResponse {
  baseMessage: {
    uuid: string,
    returnCode: number,
    returnCodeDescription: string
  },
  payload: {
    messageSent: boolean,
    referralId: string
  }
}

export enum PRODUCER_URL_PARAM_KEYS {
    AGENT_NAME = 'agentName',
    AGENT_CODE = 'agentCode',
    AGENCY_NUMBER = 'agencyNumber',
    YEAR = 'year',
    BRAND_NAME = 'brandName',
    USER_ID = 'userId',
    EMAIL_TYPE_PREFERENCE = 'emailTypePreference'
  }

@Injectable({
  providedIn: 'root'
})
export class PassiveReferralLoaderService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private reducerUtilityService: ReducerUtilityService,
    private ngRedux: NgRedux<StateStructure>,
    private commonUtilityService: CommonUtilityService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) {
  }

  async assignPassiveReferralInfo(email: string) {
    const exactTargetResponse: ExactTargetResponse = await this.passiveReferralExactTarget(email);
    const componentStates = this.reducerUtilityService.getComponentStates()
    this.ngRedux.dispatch(setPassiveReferralId(exactTargetResponse.payload.referralId));
    this.ngRedux.dispatch(saveReferralType(URL_PARAM_REFERRAL_TYPE.PERSONAL_PRODUCER_URL));
    componentStates.PrePopulateData.prepopulatedFields.emailAddress = email;
    await this.commonUtilityService.registerReferralClick(exactTargetResponse.payload.referralId);
  };

  passiveReferralExactTarget(email: string): Promise<any> {
    const passiveReferralData: ProducerUrlSessionObject = this.reducerUtilityService.getState('PassiveReferrals')
    const payload = {
      baseMessage: {},
      payload: { 
          deliveryMethod:'EMAIL',
          deliveryRecipient: email,
          templateName: 'PRODUCER_URL',
          etAttributes:  
          [{
            name: 'agentName',
            value: passiveReferralData.agentName
          },
          {
            name: 'agentCode',
            value: passiveReferralData.agentCode
          },
          {
            name: 'EmailTypePreference',
            value: passiveReferralData.emailTypePreference
          },
          {
            name: 'agencyNumber',
            value: passiveReferralData.agencyNumber
          },{

            name: 'Brand_Name',
            value: passiveReferralData.curBrandCode
          },
          {
            name: 'user_ID',
            value: passiveReferralData.userId
          },
          {
            name: 'year',
            value: passiveReferralData.year
          }
          ] 
      }
    };
    const env = this.commonUtilityService.getTestEnvironment();
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      headers: new HttpHeaders({
        'x-hmhs-test-backend': `wasinter${env}.highmark.com`
      }),
      withCredentials: true,
      POST_OR_PUT_PAYLOAD: payload,
      url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.EMAIL_SERVICES.SEND_EMAIL_EXACTTARGET, {})
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig); 
  }



  }